import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import React, { useEffect } from 'react';
import { AddEditProps, HandoverProtocol } from '../models/table-models';
import { CustomToastContent } from '../components/CustomToastContent';
import { HandoverProps } from '../models/warehouse-models';
import { transformDateToString } from '../utils/helper-functions';
import { getHandover } from '../utils/warehouses-hooks';
import { toastOptionsTopRight } from '../utils/Enums/ToastOptions';

export const AddEditProtocol = ({ itemToEdit, setShowModal }: AddEditProps<HandoverProtocol>) => {
    const { t } = useTranslation('translation', { keyPrefix: 'table' });

    const print = async (handover: HandoverProtocol) => {
        const handoverData: HandoverProps = {
            id: handover.id,
            representative: handover.clientRepresentative,
            date: transformDateToString(handover.date, 'dd.mm.yyyy'),
            town: handover.city,
            taskItemsVO: {
                branchId: handover.branchId,
                userId: handover.distributorId,
                neededItems: handover.items,
                taskId: handover.taskId,
                taskCategory: handover.taskCategory,
            },
            save: false,
            signature: handover.signature,
        };
        const pdfFile = await getHandover(handoverData);
        if (pdfFile) {
            const pdf = URL.createObjectURL(pdfFile);
            window.open(pdf, '_blank');
            return true;
        } else {
            toast.error(<CustomToastContent content={[`${t('printError')}`]} whiteText />, toastOptionsTopRight);
            return false;
        }
    };
    useEffect(() => {
        setShowModal(false);
        itemToEdit && print(itemToEdit);
    }, []);

    return <></>;
};
